import { Link } from "react-router-dom"
import Toggle from "./Toggle";

const PageHeader = ({ title,showCreateButton,url }) => {
  return (
    <div className='border-b border-gray-200 dark:bg-slate-800 dark:text-slate-100 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8'>
      <div className='flex-1 min-w-0'>
        <h1 className='text-lg font-medium leading-6 text-gray-900 dark:bg-slate-800 dark:text-slate-100 sm:truncate'>
          {title}
        </h1>
      </div>
      {showCreateButton &&
        <div className='mt-4 flex sm:mt-0 sm:ml-4 dark:bg-slate-800'>
        <Link
          to={url}
          aria-current='page'
          className='order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md dark:bg-slate-100 text-white dark:text-slate-900 bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-1 sm:ml-3'
        >
          Create
        </Link>
      </div>
      }
      
    </div>
  );
};

export default PageHeader;
